var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSparkles(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.6667 5V11.6667M28.3333 8.33333H35M31.6667 28.3333V35M28.3333 31.6667H35M16.6667 8.33333L14.2167 14.5454C13.9035 15.3395 13.7469 15.7365 13.5071 16.0713C13.2946 16.3681 13.0347 16.6279 12.738 16.8405C12.4032 17.0802 12.0061 17.2368 11.212 17.55L5 20L11.212 22.45C12.0061 22.7632 12.4032 22.9198 12.738 23.1595C13.0347 23.3721 13.2946 23.6319 13.5071 23.9287C13.7469 24.2635 13.9035 24.6605 14.2167 25.4546L16.6667 31.6667L19.1167 25.4546C19.4298 24.6605 19.5864 24.2635 19.8262 23.9287C20.0388 23.6319 20.2986 23.3721 20.5954 23.1595C20.9302 22.9198 21.3272 22.7632 22.1213 22.45L28.3333 20L22.1213 17.55C21.3272 17.2368 20.9302 17.0802 20.5954 16.8405C20.2986 16.6279 20.0388 16.3681 19.8262 16.0713C19.5864 15.7365 19.4298 15.3395 19.1167 14.5454L16.6667 8.33333Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSparkles);
export default __webpack_public_path__ + "static/media/sparkles.038e58b8dfc01faca2df1873cac181c9.svg";
export { ForwardRef as ReactComponent };